<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { GemeindeCollection, type Gemeinde } from '@/models/Gemeinde';
import { onMounted, ref, watch, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';

const value: Ref<any> = defineModel();

const props = withDefaults(
    defineProps<{
        label?: string | null;
        kantonFilter?: number | null;
        preventInitialLoading?: boolean | null;
        mandant?: boolean;
    }>(),
    { label: () => useI18n().t('gemeinde'), preventInitialLoading: false, mandant: false },
);

const gemeinden = new GemeindeCollection();
const loading = ref<boolean>(false);

watch(
    () => props.kantonFilter,
    async (newVal) => {
        if (newVal) {
            await fetchGemeinden();
        }
    },
);

async function fetchGemeinden() {
    loading.value = true;
    gemeinden.setQueryParams({
        filter: [
            props.kantonFilter
                ? {
                      id: 'kanton_id',
                      property: 'kanton_id',
                      value: props.kantonFilter,
                  }
                : null,
            props.mandant
                ? {
                      id: 'mandant',
                      property: 'mandant',
                      value: 'true',
                  }
                : null,
        ],
    });
    await gemeinden.query();
    loading.value = false;
}

onMounted(async () => {
    if (!props.preventInitialLoading) {
        await fetchGemeinden();
    }
});
</script>
<template>
    <KpSelectField
        :loading="loading"
        :label="label"
        v-model="value"
        :options="gemeinden.getModels()"
        filter
        option-label="bezeichnung"
        option-value="id"
    ></KpSelectField>
</template>
